import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface ConfigState {
  defaultLanguage: string;
  languages: {
    LanguageId: string;
    LanguageName: string;
    IsDefault: boolean;
  }[];
}

const initialState: ConfigState = {
  languages: [],
  defaultLanguage: 'tr',
};

const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    setLanguages: (state, action: PayloadAction<any>) => {
      state.defaultLanguage = action.payload.find((lang: any) => lang.IsDefault)?.LanguageId || 'tr';
      state.languages = action.payload;
    },
  },
});

export const { setLanguages } = configSlice.actions;
export default configSlice.reducer;
